import React from 'react';
import { Hero } from '../components/site/Hero';
import { Positioning } from '../components/site/Positioning';
import { WhyNotATS } from '../components/site/WhyNotATS';
import { Scenarios } from '../components/site/Scenarios';
import { HowItWorks } from '../components/site/HowItWorks';
import { SessionTrace } from '../components/site/SessionTrace';
import { DecisionRecord } from '../components/site/DecisionRecord';
import { Pipeline } from '../components/site/Pipeline';
import { Compliance } from '../components/site/Compliance';
import { StatusStrip } from '../components/site/StatusStrip';
import { Contact } from '../components/site/Contact';
export function Home() {
  return <>
      {/* The problem and the position */}
      <Hero data-id="element-472" data-mp="2dii69hgyf0wk" />
      <Positioning data-id="element-473" data-mp="2dj1lurj4td7f" />
      <WhyNotATS data-id="element-474" data-mp="2dfdt3uligutr" />

      {/* What the assessment actually is */}
      <Scenarios data-id="element-475" data-mp="3kuqv182hprik" />
      <HowItWorks data-id="element-476" data-mp="3kxd3d9x7gb1u" />

      {/* What you see and what you keep */}
      <SessionTrace data-id="element-477" data-mp="3ovu7rlp8r7fk" />
      <DecisionRecord data-id="element-478" data-mp="3ov2fajqxxpti" />

      {/* Why it holds, and whether it is safe to deploy */}
      <Pipeline data-id="element-479" data-mp="30vgjsc74whmb" />
      <Compliance data-id="element-480" data-mp="30w02hv4lza1e" />

      {/* Where we are, and how to start */}
      <StatusStrip data-id="element-481" data-mp="2vyq9k5i0gg8t" />
      <Contact data-id="element-482" data-mp="2vy820cpwefll" />
    </>;
}